import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import db from "@/firebase/init";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: false,
    userIsAdmin: false,
    company: null,
    companies: null,
    year: new Date().getFullYear()
  },
  mutations: {
    SET_USER: (state, user) => {
      state.user = user;
      
      if(user == null) {
        return;
      }

      state.userIsAdmin = user.username === "Admin";
    },
    SET_YEAR: (state, year) => {
      state.year = year;
    },
    SET_COMPANY: (state, company) => {
      state.company = company;
    },
    SET_COMPANY_BY_ID: (state, companyId) => {
      state.company = state.companies[companyId];
    },
    SET_DEFAULT_COMPANY: state => {
      state.company = state.companies[state.user ? state.user.companyId : 0];
    },
    SET_COMPANIES: (state, companies) => {
      state.companies = companies;
    },
  },
  actions: {
    INIT_USER: ({ commit, state }) => {
      console.log("INIT_USER");
      return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged(user => {
          console.log("user", user);
          if (user) {
            let userData = null;
            db.collection("users")
              .doc(user.uid)
              .get()
              .then(doc => {
                userData = doc.data();
                // console.log(userData);
                commit("SET_USER", { ...userData });
                  
                  if(userData.superadmin) {
                    db.collection("companies")
                    .get()
                    .then(snapshot => {
                      // console.log("got companies snapshot");
                      let companies = {};
                      snapshot.forEach(company => {
                        companies[company.id] = {
                          ...company.data(),
                        };
                      });
                      commit("SET_COMPANIES", companies);
                      resolve();

                      if (state.company === null) {
                        commit("SET_DEFAULT_COMPANY");
                      }
                      resolve();
                    })
                    .catch(err => {
                      reject(err);
                    });
                  } else {
                    db.collection("companies")
                    .doc(userData.companyId)
                    .get()
                    .then(snapshot => {
                      // console.log("got companies snapshot");
                      let companies = {};
                      companies[snapshot.id] = {
                        ...snapshot.data(),
                      };
                      commit("SET_COMPANIES", companies);
                      resolve();

                      if (state.company === null) {
                        commit("SET_DEFAULT_COMPANY");
                      }
                      resolve();
                    })
                    .catch(err => {
                      reject(err);
                    });    
                  }
              });
          } else {
            commit("SET_USER", null);
          }
        });
      });
    },
    FETCH_COMPANIES: ({ commit, state }) => {
      console.log("FETCH_COMPANIES");
      return new Promise((resolve, reject) => {
        if(state.user.superadmin) {
          db.collection("companies")
          .get()
          .then(snapshot => {
            // console.log("got companies snapshot");
            let companies = {};
            snapshot.forEach(company => {
              companies[company.id] = {
                ...company.data(),
              };
            });
            commit("SET_COMPANIES", companies);
            resolve();

            if (state.company === null) {
              commit("SET_DEFAULT_COMPANY");
            }
            resolve();
          })
          .catch(err => {
            reject(err);
          });
        } else {
          db.collection("companies")
          .doc(state.user.companyId)
          .get()
          .then(snapshot => {
            // console.log("got companies snapshot");
            let companies = {};
            companies[snapshot.id] = {
              ...snapshot.data(),
            };
            commit("SET_COMPANIES", companies);
            resolve();

            if (state.company === null) {
              commit("SET_DEFAULT_COMPANY");
            }
            resolve();
          })
          .catch(err => {
            reject(err);
          });    
        }
      });
    },
  },
  modules: {},
});
